import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Button, Group, Text, Title, Stack } from '@mantine/core';
import { IOrgJob, ISelectedMatch, ISourceMatch, ISubmitMatchesResponse } from '../PropagateMatchesTypes';
import { IAppState } from '../../../../lib/types/AppState/index';
import { submitMatches } from '../PropagateMatchesAPIs';

interface Props {
  fetchSurveyJobMatchData: (params: {
    resetSelectedMatches?: boolean;
    surveyJobMatch?: ISourceMatch;
    matchesMade?: ISubmitMatchesResponse;
  }) => void;
  orgJob: IOrgJob;
  surveyJobMatches: ISourceMatch[];
}

const Job: React.FC<Props> = ({ fetchSurveyJobMatchData, orgJob, surveyJobMatches }) => {
  const masterAccountID = useSelector((state: IAppState) => state.session.organization.masterAccountId);
  const surveyYear = useSelector((state: IAppState) => state.session.benchmarkYear);

  const propagateMatches = useMemo(() =>
    surveyJobMatches.flatMap(match =>
      match.selectedPropagateRows.filter((row: ISelectedMatch) => !row.matchExists && row.isChecked)
    ), [surveyJobMatches]);

  const handleSubmit = async () => {
    const matchesToSubmit = propagateMatches.map(match => ({
      targetJobId: match.targetJobId,
      cutId: match.cutId,
    }));

    const results = await submitMatches({
      masterAccountID,
      propagateMatches: matchesToSubmit,
      surveyYear,
    });

    fetchSurveyJobMatchData({resetSelectedMatches: true, matchesMade: results.data});
  };

  const jobDetails = `${orgJob.jobTitle || '-'} | ${orgJob.orgJobCode} | ${orgJob.orgJobCodeKey === ' ' ? 'Not Set' : orgJob.orgJobCodeKey} | ${orgJob.currency}`;

  return (
    <Group
      bg="ghost.5"
      className="job-descriptor__bar"
      component="div"
      justify="space-between"
      m="20 0"
      p="15 20"
    >
      <Stack>
        <Text>Propagate from Job</Text>
        <Title size="h6">{jobDetails}</Title>
      </Stack>
      <Button
        disabled={propagateMatches.length === 0}
        fz="sm"
        onClick={handleSubmit}
        size="md"
        td="none"
        variant="outline"
      >
        {`Submit ${propagateMatches.length} Match(es)`}
      </Button>
    </Group>
  );
};

export default Job;
